// Profile and onboarding sagas
import { put, select } from 'redux-saga/effects';
import { captureException } from '@sentry/browser';
import type { Action } from 'redux-actions';

// Services
import { ErrorCategory, handleError } from '@services/errorService';

// Api
import client from '@api';

// Actions
import { ChangeUsername, PassUserOnboarding } from '@actions/user';
import { SetRedirectControl } from '@actions/redirectControl';
import { SetFormError } from '@actions/formError';
import { SetLoading } from '@actions/loading';
import { SaveAccountDetails, UpdatedMarbleUser } from '@actions/user';

import { applicationErrors } from '../../contstants/error';
import {
  passOnboarding,
  saveUserSettingsMutation,
} from '../../graphql/mutations/account';

// Types
import type { RootState } from '@app-types/index';

import { mutateCheckUsername } from './apiHelpers';
import type {
  AccountDetailsPayload,
  ChangeUserSettingsResponse,
  CheckUsernameResponse,
  UsernamePayload,
} from './types';

export function* changeName({
  payload,
}: Action<UsernamePayload>): Generator<unknown, void, unknown> {
  try {
    yield put(SetLoading(true));
    const response = (yield mutateCheckUsername(
      payload,
    )) as CheckUsernameResponse;
    const isUsernameValid = response.data.checkUsername;
    if (isUsernameValid) {
      throw new Error('FIX THIS SHIT');
      // yield mutateChangeUsername(payload);
    } else {
      yield put(
        SetFormError({
          form: 'username',
          error: applicationErrors.un_1,
        }),
      );
    }
  } catch (error) {
    yield put(
      SetFormError({
        form: 'username',
        error: { username: 'Error occurs' },
      }),
    );
    handleError(error, { category: ErrorCategory.AUTH });
  } finally {
    yield put(SetLoading(false));
  }
}

export function* finishOnboarding(): Generator<unknown, void, unknown> {
  try {
    const username = (yield select(
      (state: RootState) => state.User.username,
    )) as string | null;
    const shop = localStorage.getItem('shopify_shop');
    const tokenFromShopify = localStorage.getItem('shopify_token');
    const redirectUrlFromShopify = localStorage.getItem('shopify_redirect_url');
    const setupAuthTaskSecret =
      typeof localStorage === 'object'
        ? localStorage.getItem('setupAuthTaskSecret')
        : null;

    yield client().mutate({ mutation: passOnboarding });

    if (shop && tokenFromShopify && redirectUrlFromShopify) {
      yield put(SetRedirectControl(`/connect`));
    } else {
      if (setupAuthTaskSecret) {
        yield put(SetRedirectControl('/campaigns'));
      } else {
        yield put(SetRedirectControl(`/${username}`));
      }
    }
  } catch (error) {
    captureException(error);
  }
}

export function* saveAccountDetailsSaga({
  payload,
}: Action<AccountDetailsPayload>): Generator<unknown, void, unknown> {
  try {
    yield put(SetLoading(true));

    const response = (yield client().mutate({
      mutation: saveUserSettingsMutation,
      variables: {
        input: {
          profile: {
            fullName: payload?.fullName,
            username: payload?.username,
          },
        },
      },
    })) as ChangeUserSettingsResponse;

    const changeUserSettings = response.data.changeUserSettings;

    yield put(
      UpdatedMarbleUser({
        username: changeUserSettings?.shareableSettings?.username,
        shareableSettings: changeUserSettings.shareableSettings,
      }),
    );

    localStorage.setItem('onboardingPath', '/onboarding/link');
    yield put(SetRedirectControl('/onboarding/link'));
  } catch (error) {
    const err = error as Error;
    const parsed = applicationErrors.parse(err.message);
    yield put(SetFormError({ form: 'accountSettings', error: parsed }));
  } finally {
    yield put(SetLoading(false));
  }
}

// Action creators for watchers
export const profileActions = {
  ChangeUsername,
  PassUserOnboarding,
  SaveAccountDetails,
};
